import { IconButton, SvgClose } from '@loomhq/lens';
import cn from 'classnames';
import React from 'react';

import { useNavigationStore } from 'components/layout/navigation/navigation-store';

import styles from './styles.module.less';

function SidebarCtaContainer({
  className = 'items:center',
  color = 'var(--lns-color-body)',
  backgroundColor = 'var(--lns-color-blurpleLight)',
  borderColor = 'var(--lns-color-blurpleMedium)',
  onDismiss,
  children,
  onClick,
  width = 'var(--navSidebarInnerWidth)',
}) {
  const { toggleSidebar, isCollapsed } = useNavigationStore();
  const Element = onClick ? 'button' : 'div';

  return (
    <Element
      onClick={() => isCollapsed && toggleSidebar()}
      style={{ width, backgroundColor, borderColor, color }}
      className={cn(
        className,
        styles.ctaContainer,
        isCollapsed && styles.isCollapsed
      )}
    >
      {!isCollapsed && onDismiss && (
        <div className="absolute top:0 right:0">
          <IconButton
            altText="Dismiss"
            icon={<SvgClose />}
            onClick={event => onDismiss(event)}
          />
        </div>
      )}
      {children}
    </Element>
  );
}

export default SidebarCtaContainer;
